module.exports = __webpack_public_path__ + "static/img/pic-homepage-cooperation3.d6b3779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-cooperation3.png
// module id = 965
// module chunks = 0